import Share from '../components/Share'

function Epilog() {
  return (
    <div>
      <h1>Gå i dybden</h1>
      <p>Læs mere og leg selv med coronadata på</p>
      <a href="https://observablehq.com/@jacobkjaersgaardhansen/corona">https://observablehq.com/<br />@jacobkjaersgaardhansen/corona</a>
      <Share />
    </div>
  )
}

export default Epilog